import React from "react";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import {
  CSR_PERFORMANCE_EFFECTIVENESS_HEADERS,
  CSR_PERFORMANCE_PERFORMANCE_HEADERS
} from "../../../../constants/table-custom-headers/Auditor";
import i18n from "../../../../constants/i18n";
import getCSRsPerformanceStore from "../../../../stores/auditor-store/csrs-performance-store";

const PerformanceData = withLiteObserverAndTheme(() => {
  const performanceData = getCSRsPerformanceStore()
    .performanceData.get()
    .map((e) => {
      return {
        ...e,
        page_name: e.pageName
      };
    });

  return (
    <React.Fragment>
      <Et3Table
        columns={CSR_PERFORMANCE_PERFORMANCE_HEADERS}
        rows={performanceData}
        title={i18n.get("PERFORMANCE")}
        shouldBeFlagged={false}
        titleKey={"PERFORMANCE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={CSR_PERFORMANCE_EFFECTIVENESS_HEADERS}
        rows={getCSRsPerformanceStore().effectivenessDataOrdered.get()}
        title={i18n.get("EFFECTIVENESS")}
        shouldBeFlagged={false}
        titleKey={"EFFECTIVENESS"}
      />
    </React.Fragment>
  );
});

export default PerformanceData;
